import {useEffect} from 'react';

export default function useHandleFormReady(formMethods, formInputs, isFormReady, setFormReady, shouldBypassForm = false) {
    const {flatInputsWithoutHidden, state: {isFinished} = {}} = formInputs ?? {};

    useEffect(() => {
        if (!isFormReady && (shouldBypassForm || (isFinished && flatInputsWithoutHidden?.every(({key}) => Object.keys(formMethods.getValues()).includes(key))))) {
            setFormReady(true);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formMethods.getValues, flatInputsWithoutHidden, isFinished, shouldBypassForm]);
}
